import { CommonMessage } from '@frontend/lang';
import { StockExtended } from '@frontend/stock/types';

import ImagePlaceholder from '../../../../assets/images/image-placeholder.png';
import { useStockCard } from './stock-card.controller';

export interface StockCardProps {
    stock: StockExtended;
    onRemove?: () => void;
}

export const StockCard = (props: StockCardProps) => {
    const viewProps = useStockCard(props);

    return (
        <div className='bg-background-surface border-border-default text-foreground-default w-full rounded-xl border p-4 font-medium'>
            <div className='flex w-full flex-col'>
                <div className='flex w-full items-start gap-3'>
                    <div className='size-20 shrink-0 overflow-hidden rounded'>
                        <img
                            src={viewProps.imageUrl ?? ImagePlaceholder}
                            alt=''
                            className='size-full object-contain'
                        />
                    </div>
                    <div className='flex min-w-0 flex-1 flex-col gap-3'>
                        {viewProps.productTitle}
                        {viewProps.attributes && Object.keys(viewProps.attributes).length > 0 && (
                            <div className='flex flex-wrap gap-1'>
                                {Object.entries(viewProps.attributes).map(([key, value]) => (
                                    <span
                                        key={key}
                                        className='bg-border-default rounded px-1 text-sm'>
                                        {key}: {value}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <button
                    type='button'
                    className='text-brand-primary w-fit items-start justify-start disabled:opacity-50'
                    onClick={viewProps.handleRemoveClick}
                    disabled={viewProps.isRemoving || !viewProps.canRemove}>
                    {CommonMessage.BUTTONS.REMOVE}
                </button>
            </div>
        </div>
    );
};
